import { useContext } from 'react';

import { ProfileStateContext } from '../../context/ProfileDataContext';
import { AvatarManifestItem } from '../../utils/interfaces/DbInterfaces';

// Custom hook to get avatar manifest from context
export const useAvatarManifest = (): Record<string, AvatarManifestItem> => {
  const { avatarAssets, unlockRules, avatarAssetsLoaded } = useContext(ProfileStateContext);
  const manifest: Record<string, AvatarManifestItem> = {};

  // If assets are not loaded yet, return empty manifest
  if (!avatarAssetsLoaded || Object.keys(avatarAssets).length === 0) {
    return manifest;
  }

  // Process assets from the API
  Object.entries(avatarAssets).forEach(([key, asset]) => {
    // Map unlock type from API to existing format
    const getUnlockType = (ruleType: string): string => {
      switch (ruleType) {
        case 'xp':
          return 'xp';
        case 'exercise':
          return 'exercises';
        case 'practiceTest':
          return 'quiz';
        case 'free':
          return 'free';
        case 'streak':
          return 'streak';
        case 'challenge':
          return 'challenge';
        case 'course':
          return 'course';
        case 'certificate':
          return 'certificate';
        case 'subscription':
          return 'subscription';
        case 'fullAccess':
          return 'fullAccess';
        case 'plan':
          return 'plan';
        default:
          return 'xp';
      }
    };

    const assetUnlockRules = unlockRules[key] || [];
    const firstRule = assetUnlockRules[0];

    manifest[key] = {
      id: key,
      slot: asset.slot as any,
      z: asset.z,
      unlockAt: firstRule?.value || 0,
      name: asset.name,
      svg: asset.svg,
      previewSvg: asset.previewSvg, // Add previewSvg for achievements display
      slotLabel: asset.slotLabel,
      unlockType: getUnlockType(firstRule?.type || 'free') as any,
      previewScale: 1.0, // Default scale
      previewOffset: { x: 0, y: 0 }, // Default offset
    };
  });

  return manifest;
};

// Keep the default export for backward compatibility
// Note: This will be empty initially until assets are loaded
const avatarManifest: Record<string, AvatarManifestItem> = {};
export default avatarManifest;
